import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/ads-conversions")({
  component: lazyRouteComponent(() => import("./-pages/admin.ads-conversions")),
  head: () => ({
    meta: [
      { title: "Ads Conversions · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
